export default __webpack_public_path__ + "img/payment-methods.a36de99f.png";